import { render, staticRenderFns } from "./subrole.vue?vue&type=template&id=63bdce10&scoped=true&"
import script from "./subrole.vue?vue&type=script&lang=js&"
export * from "./subrole.vue?vue&type=script&lang=js&"
import style0 from "./subrole.vue?vue&type=style&index=0&id=63bdce10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bdce10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bdce10')) {
      api.createRecord('63bdce10', component.options)
    } else {
      api.reload('63bdce10', component.options)
    }
    module.hot.accept("./subrole.vue?vue&type=template&id=63bdce10&scoped=true&", function () {
      api.rerender('63bdce10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/subrole/subrole.vue"
export default component.exports